import BoxInfo from '@/components/boxInfo/boxInfo';
import EmptyMessage from '@/components/emptyMessage';
import { Address, LifeNormalized } from '@/modules/beneficiary/entities/interfaces/life';
import Display from '@/shared/modules/address/views/display/display';
import React from 'react';

interface LifeAddressesProps {
  life?: Partial<LifeNormalized>;
}

const LifeAddresses: React.FC<LifeAddressesProps> = ({ life }) => {
  const addresses = life?.addresses || [];
  const hasAddresses = addresses.length > 0;

  const renderAddressDisplay = (address: Address, index: number) => (
    <Display
      key={index}
      isLoading={false}
      title={`Dados de endereço ${addresses.length > 1 ? index + 1 : ''}`}
      icon='pin-outline'
      address={address}
    />
  );

  const addressDisplays = hasAddresses ? addresses.map(renderAddressDisplay) : null;

  return (
    <>
      {addressDisplays}

      {!hasAddresses && (
        <BoxInfo icon='pin-outline' title='Dados de endereço'>
          <EmptyMessage title='Nada por aqui!' description='Nenhum endereço cadastrado.' />
        </BoxInfo>
      )}
    </>
  );
};

export default LifeAddresses;
